<template>
  <div class="goods-info">
    <div>
      <el-form
        v-if="orderEditType!==2"
        ref="goodsInfoFilter"
        :model="form"
        label-width="90px"
        @submit.native.prevent
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              label="包装号"
              prop="packageNo"
            >
              <el-input v-model="form.packageNo" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="SKU号"
              prop="itemNo"
            >
              <el-input v-model="form.itemNo" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="生产商"
              prop="producerName"
            >
              <el-input v-model="form.producerName" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-button
                type="primary"
                @click="()=>handleQuery(1)"
              >搜索</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div>
      <div
        v-if="orderEditType===1 && poState===0"
        class="trigger"
        style="flex:1"
      >
        <el-form>
          <el-button
            type="primary"
            @click="handleAdd"
          >新增</el-button>
          <el-button
            type="primary"
            @click="handleEdit"
          >编辑</el-button>
          <el-button
            type="primary"
            @click="handleDel"
          >删除</el-button>
        </el-form>
      </div>
      <div
        v-if="sumInfo && orderEditType!==2"
        style="display:flex;align-items:center"
      >
        <div
          :class="['total',form.eqFlag?'notEq':'' ]"
          @click="totalClick"
        >总包装数:{{ sumInfo.sumEstimatedQuantity }}/<span :style="{color:sumInfo.sumEstimatedQuantity===sumInfo.sumQuantity?'':'red'}">{{ sumInfo.sumQuantity }}</span></div>
        <div style="margin:0 10px">总体积(CBM):{{ sumInfo.sumEstimatedCubage }}/{{ sumInfo.sumCubage }}</div>
        <div>总重量(KGS):{{ sumInfo.sumEstimatedGrossWeight }}/{{ sumInfo.sumGrossWeight }}</div>
      </div>
    </div>
    <div style="display: flex;margin-top: 5px">
      <cargo-ag-grid
        ref="goodsTable"
        config-module="700003"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        style="height: 400px"
        :row-data="rowData"
      />
    </div>
    <div>
      <el-form>
        <cargo-pagination
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
          @pagination="()=>handleQuery()"
        />
      </el-form>
    </div>
    <package-info-form
      ref="packageInfoForm"
      :visible="visible"
      :uuid="editRow?editRow.uuid : null"
      :po-no="poNo"
      :order-uuid="orderUuid"
      :customer-id="customerId"
      @onSave="goodsSave"
      @onClose="handleClose"
    />
  </div>
</template>
<script>
import packageInfoForm from './packageInfoForm'
import { getLoading } from '@/utils/utilBaseElement'
import {
  queryPoPackageItemPageable,
  savePoPackage,
  deletePoPackages,
  queryPoPackageSumInfo
} from '@/api/OMS/order'
import { formatRoundNumber } from '@/utils/NumberUtils'
export default {
  name: 'PackageInfo',
  components: { packageInfoForm },
  props: {
    orderEditType: {
      type: Number,
      default: () => 2
    },
    orderUuid: { type: String, default: () => '' },
    poNo: { type: String, default: () => '' },
    poState: { type: Number, default: () => null },
    customerId: { type: Number, default: () => null }
  },
  data() {
    return {
      visible: false,
      form: {
        packageNo: '',
        itemNo: '',
        producerName: '',
        eqFlag: ''
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        columnApi: null,
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: (item) => {
            const { data } = item
            if (!data.packageNo) {
              return false
            }
            return true
          },
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: '包装号',
          colId: 'packageNo',
          field: 'packageNo',
          width: 150
        },
        {
          headerName: '包装类型',
          colId: 'packageType',
          field: 'packageType',
          width: 150
        },
        {
          headerName: '包装数(预/实)',
          colId: 'quantity',
          field: 'quantity',
          width: 150,
          cellStyle: (item) => {
            const { data } = item
            if (data && data.quantity !== data.estimatedQuantity) {
              return { 'color': 'red' }
            }
            return {}
          },
          cellRenderer: (item) => {
            const { data } = item
            return `${data.estimatedQuantity}/${data.quantity}`
          }
        },
        {
          headerName: '纸箱数',
          colId: 'cartonQuantity',
          field: 'cartonQuantity',
          width: 150
        },
        {
          headerName: 'SKU编码',
          colId: 'itemNo',
          field: 'itemNo',
          width: 150
        },
        {
          headerName: 'SKU数量',
          colId: 'itemQuantity',
          field: 'itemQuantity',
          width: 150
        },
        {
          headerName: '总件数',
          colId: 'totalQuantity',
          field: 'totalQuantity',
          width: 150
        },
        {
          headerName: '长(预/实)(cm)',
          colId: 'length',
          field: 'length',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `${data.estimatedLength}/${data.length}`
          }
        },
        {
          headerName: '宽(预/实)(cm)',
          colId: 'width',
          field: 'width',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `${data.estimatedWidth}/${data.width}`
          }
        },
        {
          headerName: '高(预/实)(cm)',
          colId: 'height',
          field: 'height',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `${data.estimatedHeight}/${data.height}`
          }
        },
        {
          headerName: '单件体积(预/实)(m³)',
          colId: 'unitCubage',
          field: 'unitCubage',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            return `${data.estimatedUnitCubage}/${data.unitCubage}`
          }
        },
        {
          headerName: '单件毛重(预/实)(KG)',
          colId: 'unitGrossWeight',
          field: 'unitGrossWeight',
          width: 150,
          cellStyle: (item) => {
            const { data } = item
            if (data && data.unitGrossWeight !== data.estimatedUnitGrossWeight) {
              return { 'color': 'red' }
            }
            return {}
          },
          cellRenderer: (item) => {
            const { data } = item
            return `${data.estimatedUnitGrossWeight}/${data.unitGrossWeight}`
          }
        },
        {
          headerName: '总体积(预/实)(m³)',
          colId: 'cubage',
          field: 'cubage',
          width: 150,
          cellStyle: (item) => {
            const { data } = item
            if (data && data.cubage !== data.estimatedCubage) {
              return { 'color': 'red' }
            }
            return {}
          },
          cellRenderer: (item) => {
            const { data } = item
            return `${data.estimatedCubage}/${data.cubage}`
          }
        },
        {
          headerName: '总毛重(预/实)',
          colId: 'grossWeight',
          field: 'grossWeight',
          width: 150,
          cellStyle: (item) => {
            const { data } = item
            if (data && data.grossWeight !== data.estimatedGrossWeight) {
              return { 'color': 'red' }
            }
            return {}
          },
          cellRenderer: (item) => {
            const { data } = item
            return `${data.estimatedGrossWeight}/${data.grossWeight}`
          }
        },
        {
          headerName: '生产商',
          colId: 'producerName',
          field: 'producerName',
          width: 150
        },
        {
          headerName: '预计货好时间',
          colId: 'estimatedIncomeDate',
          field: 'estimatedIncomeDate',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '实际进仓时间',
          colId: 'warehouseInDate',
          field: 'warehouseInDate',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '实际出仓时间',
          colId: 'warehouseOutDate',
          field: 'warehouseOutDate',
          width: 150,
          valueFormatter(params) {
            return params.value ? params.value.split(' ')[0] : ''
          }
        },
        {
          headerName: '进仓编号',
          colId: 'warehouseNo',
          field: 'warehouseNo',
          width: 150
        },
        {
          headerName: '注意事项',
          colId: 'matters',
          field: 'matters',
          width: 150
        },
        {
          headerName: '来源',
          colId: 'sourceFileName',
          field: 'sourceFileName',
          width: 150
        },
        {
          headerName: '箱号',
          colId: 'containerno',
          field: 'containerno',
          width: 150
        },
        {
          headerName: '箱型',
          colId: 'eqsize',
          field: 'eqsize',
          width: 150
        },
        {
          headerName: '箱种',
          colId: 'eqtype',
          field: 'eqtype',
          width: 150
        },
        {
          headerName: '封号',
          colId: 'sealno',
          field: 'sealno',
          width: 150
        },
        {
          headerName: '创建人',
          colId: 'createUserName',
          field: 'createUserName',
          width: 150
        },
        {
          headerName: '接收时间',
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 150
        },
        {
          headerName: '更新人',
          colId: 'modifyUserName',
          field: 'modifyUserName',
          width: 150
        },
        {
          headerName: '更新时间',
          colId: 'dateModified',
          field: 'dateModified',
          width: 150
        }
      ],
      rowData: [],
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      editRow: null,
      sumInfo: null
    }
  },
  watch: {
    orderUuid(newVal, oldVal) {
      if (!newVal) {
        this.rowData = []
      }
      if (newVal && newVal !== oldVal) {
        this.fetchList()
      }
    }
  },
  methods: {
    fetchList() {
      this.loading = getLoading()
      const params = {
        poInfoUuid: this.orderUuid,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize
      }
      Object.keys(this.form).forEach((key) => {
        if (this.form[key]) {
          params[key] = this.form[key]
        }
      })
      queryPoPackageItemPageable(params)
        .then((res) => {
          this.rowData = res.data.list
          this.filter.total = Number(res.data.total)
          this.loading.close()
        })
        .catch(() => {
          this.loading.close()
        })
      queryPoPackageSumInfo({ poInfoUuid: this.orderUuid }).then((res) => {
        const {
          sumCubage,
          sumEstimatedCubage,
          sumEstimatedGrossWeight,
          sumEstimatedQuantity,
          sumGrossWeight,
          sumQuantity
        } = res.data
        this.sumInfo = {
          sumCubage: sumCubage ? formatRoundNumber(sumCubage, 3) : 0,
          sumEstimatedCubage: sumEstimatedCubage
            ? formatRoundNumber(sumEstimatedCubage, 3)
            : 0,
          sumEstimatedGrossWeight: sumEstimatedGrossWeight
            ? formatRoundNumber(sumEstimatedGrossWeight, 2)
            : 0,
          sumEstimatedQuantity: sumEstimatedQuantity || 0,
          sumGrossWeight: sumGrossWeight
            ? formatRoundNumber(sumGrossWeight, 2)
            : 0,
          sumQuantity: sumQuantity || 0
        }
      })
    },
    handleQuery(type = 0) {
      if (type !== 0) {
        this.filter.pageNum = 1
      }
      this.fetchList()
    },
    handleReset() {
      this.$refs['goodsInfoFilter'].resetFields()
      this.filter.pageNum = 1
      this.form.eqFlag = ''
      this.fetchList()
    },
    goodsSave(item) {
      const { poPackageItemList } = item
      const hasCur = poPackageItemList.filter(
        (poItem) => poItem.poInfoUuid === this.orderUuid
      )
      if (hasCur.length === 0) {
        this.$message.warning('包装中没有当前订单的商品')
        this.$refs.packageInfoForm.loading.close()
        return
      }
      const params = {
        ...item
      }
      savePoPackage(params)
        .then((res) => {
          this.$message.success('保存成功')
          this.$refs.packageInfoForm.loading.close()
          this.handleQuery(1)
          this.handleClose()
        })
        .catch(() => {
          this.$refs.packageInfoForm.loading.close()
        })
    },
    handleClose() {
      this.visible = false
      this.editRow = null
      this.$refs.packageInfoForm.$refs.form.resetFields()
    },
    handleAdd() {
      if (this.orderEditType === 2) {
        this.$message.error('请先保存订单')
        return
      }
      this.visible = true
    },
    handleEdit() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows().filter((item) => {
        return item.packageNo
      })
      if (selectedRows.length === 0) {
        this.$message.error('请选择一条数据')
        return
      }
      if (selectedRows.length > 1) {
        this.$message.error('一次只能编辑一条数据')
        return
      }
      this.editRow = selectedRows[0]
      this.visible = true
    },
    handleDel() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows().filter((item) => {
        return item.packageNo
      })
      if (selectedRows.length === 0) {
        this.$message.error(this.$t('CargoMsg.Cargo_SelectPackage'))
        return
      }
      const h = this.$createElement
      let outPackageNos = ''// 未入仓包装
      let inPackageNos = ''// 已入仓包装
      const uuids = []
      selectedRows.forEach(item => {
        if (item.warehouseInDate) {
          inPackageNos = inPackageNos + '，' + item.packageNo
        } else {
          outPackageNos = outPackageNos + '，' + item.packageNo
        }
        uuids.push(item.uuid)
      })
      const inArr = []
      const outArr = []
      inPackageNos = inPackageNos.slice(1, inPackageNos.length)
      outPackageNos = outPackageNos.slice(1, outPackageNos.length)
      this.getPackageArr(inArr, inPackageNos)
      this.getPackageArr(outArr, outPackageNos)
      let content = ''
      let tip = ''
      // 若已入仓和未入仓同时存在
      if (inPackageNos.length > 0 && outPackageNos.length > 0) {
        tip = this.$t('CargoMsg.Cargo_CheckPackage')
        const hContent = []
        hContent.push(h('span', null, this.$t('CargoMsg.Cargo_PackageNo')))
        hContent.push(h('br', null))
        for (let i = 0; i < inArr.length; i++) {
          hContent.push(h('span', { style: 'margin: 0 0 0 40px' }, inArr[i]))
          hContent.push(h('br', null))
        }
        hContent.push(h('span', { style: 'color: red' }, '  ' + this.$t('CargoMsg.Cargo_WareHoused')))
        hContent.push(h('br', null))
        hContent.push(h('span', null, this.$t('CargoMsg.Cargo_PackageNo')))
        hContent.push(h('br', null))
        for (let i = 0; i < outArr.length; i++) {
          hContent.push(h('span', { style: 'margin: 0 0 0 40px' }, outArr[i]))
          hContent.push(h('br', null))
        }
        hContent.push(h('span', { style: 'color: red' }, '  ' + this.$t('CargoMsg.Cargo_NotWareHoused')))
        content = h('div', null, [
          h('p', null, hContent),
          h('p', { style: 'color: red' }, tip)
        ])
      } else if (inPackageNos.length > 0 && outPackageNos.length === 0) {
        tip = this.$t('CargoMsg.Cargo_SureDeletePackageIn')
        const hContent = []
        hContent.push(h('span', null, this.$t('CargoMsg.Cargo_PackageNo')))
        hContent.push(h('br', null))
        for (let i = 0; i < inArr.length; i++) {
          hContent.push(h('span', { style: 'margin: 0 0 0 40px' }, inArr[i]))
          hContent.push(h('br', null))
        }
        content = h('div', null, [
          h('p', null, hContent),
          h('p', { style: 'color: red' }, tip)
        ])
      } else if (inPackageNos.length === 0 && outPackageNos.length > 0) {
        tip = this.$t('CargoMsg.Cargo_SureDeleteAbovePackage')
        const hContent = []
        hContent.push(h('span', null, this.$t('CargoMsg.Cargo_PackageNo')))
        hContent.push(h('br', null))
        for (let i = 0; i < outArr.length; i++) {
          hContent.push(h('span', { style: 'margin: 0 0 0 40px' }, outArr[i]))
          hContent.push(h('br', null))
        }
        content = h('div', null, [
          h('p', null, hContent),
          h('p', { style: 'color: red' }, tip)
        ])
      }
      this.$confirm(content, this.$t('CargoMsg.Cargo_DeletePackage'), {
        type: 'warning'
      }).then(() => {
        deletePoPackages(uuids).then((res) => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.handleQuery(1)
        })
      })
    },
    // 获取value 裁切后的数据
    getPackageArr(arr, value) {
      if (value.length > 40) {
        const strValue = value.slice(0, 40)
        const last = strValue.lastIndexOf('，') + 1
        arr.push(strValue.slice(0, last))
        this.getPackageArr(arr, value.slice(last, value.length))
      } else {
        arr.push(value)
      }
    },
    totalClick() {
      this.form.eqFlag = this.form.eqFlag === 'notEq' ? '' : 'notEq'
      this.handleQuery(1)
    }
  }
}
</script>
<style lang="scss" scoped>
.total {
  cursor: pointer;
  padding: 2px;
  border-radius: 3px;
  &.notEq {
    background: #bdbdbd;
  }
}
</style>
